/**
 * @generated SignedSource<<00a4e263639fa4b02b8aa38d28b7a4c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternJobsHealthCard_metrics$data = {
  readonly avgDurationMs: number | null;
  readonly failureCount: number;
  readonly failuresLastHour: number;
  readonly jobsLastHour: number;
  readonly retryCount: number;
  readonly runningCount: number;
  readonly successCount: number;
  readonly successRate: number;
  readonly totalJobs: number;
  readonly " $fragmentType": "InternJobsHealthCard_metrics";
};
export type InternJobsHealthCard_metrics$key = {
  readonly " $data"?: InternJobsHealthCard_metrics$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternJobsHealthCard_metrics">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternJobsHealthCard_metrics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalJobs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "successCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failureCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "runningCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retryCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "successRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avgDurationMs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobsLastHour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failuresLastHour",
      "storageKey": null
    }
  ],
  "type": "JobHealthMetrics",
  "abstractKey": null
};

(node as any).hash = "7f5339089c6d9a37c4b1857dabfc5d3c";

export default node;
